<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <app-modal-back
        icon="close"
        ariaLabel="close"
      ></app-modal-back>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="form && assessmentService.assessmentData">
    <div
      class="notification ion-margin"
      *ngIf="form.value.scheduledSessions === 0"
    >
      <ion-icon name="checkmark-circle"></ion-icon>
      <div class="message">
        <p>No evaluation needed.</p>
      </div>
    </div>
    <div class="mable-section ion-padding-top">
      <mable-heading
        heading="h2"
        headingStyle="h1"
      >
        {{assessmentService.assessmentData?.isFirstWeekly ? 'First' : 'Second'}} week evaluation
      </mable-heading>
      <div class="description content ion-margin-horizontal">
        <ion-icon
          aria-hidden="true"
          name="calendar"
        ></ion-icon>
        <ion-label class="body-semi-bold">
          For {{assessmentService.assessmentData?.agreement?.otherUser?.firstName}},
          {{assessmentService.assessmentData?.periodStartDate | date :'d MMMM'}} to
          {{assessmentService.assessmentData?.periodEndDate | date :'d MMMM'}}
        </ion-label>
      </div>
      <div class="sub-section">
        <ion-img
          alt="review worker reliability"
          class="ion-padding-horizontal width-100"
          src="assets/img/mable/review-worker.svg"
        >
        </ion-img>
      </div>
      <div class="sub-section">
        <p class="ion-margin-horizontal">
          The first 2 weeks with your new support worker is important. Your anonymous input helps your support worker
          using Mable improve their services and reliability.
        </p>
      </div>
    </div>
    <form [formGroup]="form">
      <mable-input
        label="How many support sessions did you schedule?"
        [hasError]="form.get('scheduledSessions').showError()"
      >
        <p class="description">
          Between {{assessmentService.assessmentData?.periodStartDate | date :'d MMMM'}} to
          {{assessmentService.assessmentData?.periodEndDate | date :'d MMMM'}}, including no-shows.
        </p>
        <app-numeric-input
          formControlName="scheduledSessions"
          aria-required="true"
        ></app-numeric-input>
        <div class="warn">
          <p *ngIf="form.get('scheduledSessions').errors?.required">Please enter a value</p>
          <p *ngIf="form.get('scheduledSessions').errors?.min">
            {{form.value.noShows > 0 ? "Value can't be less than number of no-shows." : "Value can't be less than 0."}}
          </p>
        </div>
      </mable-input>
      <mable-input
        label="Any no-shows?"
        [hasError]="form.get('noShows').showError()"
        *ngIf="form.value.scheduledSessions !== 0 || !!form.value.scheduledSessions"
      >
        <p class="description">When your worker didn't cancel or show up to a session.</p>
        <app-numeric-input
          formControlName="noShows"
          aria-required="true"
        ></app-numeric-input>
        <div
          class="warn"
          *ngIf="form.get('noShows')?.errors as errors"
        >
          <p *ngIf="errors?.required">Please enter a value</p>
          <p *ngIf="errors?.min">Value can't be less than 0.</p>
          <p *ngIf="errors?.max">Value can't be more than number of sessions.</p>
        </div>
      </mable-input>
    </form>
  </ng-container>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <mable-button
          category="outline"
          expand="block"
          (onClick)="cancel()"
        >
          Cancel
        </mable-button>
      </ion-col>
      <ion-col>
        <mable-button
          expand="block"
          (onClick)="continue()"
        >
          {{(form.value.scheduledSessions !== 0) ? 'Continue' : 'Submit'}}
        </mable-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
